import React from "react";
import Container from "../../hoc/Container";
import { tgIcon, insale_steam } from "../../../images";

function SteamDiscount() {
  return (
    <Container>
      <div className="content-block">
        <div className="head-1">Скоро тут будут лучшие предложения Steam</div>
        <div className="mt-2 text-center">
          А пока можете посмотреть скидки здесь:
        </div>
        <div className="discount-grid mt-4">
          <a
            className="discount-card"
            href="https://store.steampowered.com/specials#tab=TopSellers"
            target="_blank"
            rel="noreferrer"
          >
            <img
              className="discount-image"
              src={insale_steam}
              alt="Скидки Steam"
            />
            <div className="discount-overlay">Посмотреть скидки Steam</div>
          </a>
        </div>
        <div className="mt-4 flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center lg:flex-nowrap">
          <a
            href="https://t.me/trendy_steam_bot?start=ref-001"
            className="mb-3 flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 md:mb-0"
            target="_blank"
            rel="noreferrer"
          >
            Купить в <img src={tgIcon} alt="TG" className="ml-2 w-4 h-4 sm:w-5 sm:h-5" />
          </a>
          <a
            href="https://trendy-eng-shop.ru/steam"
            className="mb-3 flex w-48 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 md:mb-0"
            target="_blank"
            rel="noreferrer"
          >
            Пополнить на сайте
          </a>
        </div>
      </div>
    </Container>
  );
}

export default SteamDiscount;
